export default __webpack_public_path__ + "static/media/03AW1-2AUG66.4bb178b5.jpg";